import { Box, Grid, Paper } from "@mui/material"


interface ProgressProps {
    percentage: number
}

export default function ChargingProgress({percentage}: ProgressProps) {

    return(
        <Box
        display='flex'
        alignItems='center'
        sx={{   
                height: 200,
                borderRadius: '15px',
                backgroundImage: `linear-gradient(to top, #77c768 ${percentage}%, rgba(0,0,0,0) ${percentage}%)` ,
                backgroundColor: 'rgba(119, 199, 104, 0.20)',
                fontSize: '3rem',
                fontWeight: 'bolder',
        }}>
            <Grid container direction='column' alignItems='center' justifyContent='center'>
                {percentage}%
                <p style={{ fontSize: '1rem', fontWeight: 'bolder' }}>Charging State</p>
            </Grid>
           
        </Box>
    )

}